var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { IconStructure } from '../components/IconStructure';
// Styles
import { getIconStylesByVariant } from './getIconStylesByVariant';
import { getColorByContentColor } from '../../../common/styles/getColorByContentColor';
// Utils
import styled from 'styled-components';
export var StyledIcon = styled(IconStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n\n  width: ", ";\n  height: ", ";\n\n  & > use {\n    fill: currentColor;\n  }\n"], ["\n  ", ";\n  ", ";\n\n  width: ", ";\n  height: ", ";\n\n  & > use {\n    fill: currentColor;\n  }\n"])), function (_a) {
    var styleVariant = _a.styleVariant, theme = _a.theme;
    return getIconStylesByVariant(styleVariant, theme);
}, function (_a) {
    var contentColor = _a.contentColor, theme = _a.theme;
    return contentColor && getColorByContentColor(contentColor, theme);
}, function (_a) {
    var width = _a.width;
    return width !== null && width !== void 0 ? width : 'inherit';
}, function (_a) {
    var height = _a.height;
    return height !== null && height !== void 0 ? height : 'inherit';
});
var templateObject_1;
//# sourceMappingURL=StyledIcon.js.map